// extracted by mini-css-extract-plugin
export var featureGridItemStyle = "feature_grid_item-module--featureGridItemStyle--UCSi0";
export var textStyle = "feature_grid_item-module--textStyle--Xn7g3";